// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3k5YR","outerImage":"_3akiP","contentWrap":"jQ0mK","heading":"_3QRF9","ratingText":"_3WDAa","ratingImage":"_15TQ_","content":"IfntN"};